import { Component } from '@angular/core';

@Component({
  selector: 'app-placement-report',
  imports: [],
  templateUrl: './placement-report.component.html',
  styleUrl: './placement-report.component.css'
})
export class PlacementReportComponent {

}
